import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Breadcrumbs,
  Card,
  Chip,
  Divider,
  Grid,
  Paper,
  styled,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from '@mui/material';

import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import {
  Apps,
  Person,
  Email,
  Phone,
  LocationOn,
  Event,
  Payment,
  Business,
  Star,
  VerifiedUser,
} from '@mui/icons-material';
import { formatDateToYmd } from '../../../commons/utils';
import { useDispatch, useSelector } from 'react-redux';
import { SnackAlert } from '../../../components/SnackAlert';
import CustomButtonTab from '../../../components/CustomButtonTab';
import { DetalleModulosPermisos } from './components/forms/DetalleModulosPermisos';
import {
  getApplicationsPermissionsCustomerStore,
  storeGetDetailCustomer,
} from '../../../store/customer';
import { DetailPermissions } from '../../../components/generics/DetailPermissions';
import { DetalleModuloPermisosCustomer } from './components/DetalleModuloPermisosCustomer';

export const DetailCustomer = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  // REDUX
  const { customer }: any = useSelector((state: any) => state.customer);
  const { id: customerId }: any = useParams();

  useEffect(() => {
    detalleCustomer();
  }, []);

  const detalleCustomer = async () => {
    const response = await dispatch(storeGetDetailCustomer(customerId));
    if (!response.ok) {
      setAlertSnack(true);
      setMessageAlertSnack(response.message);
      setTypeAlertSnack('error');
      return false;
    }
  };

  const [customerUpdateId, setCustomerUpdateId] = React.useState<any>();

  const [value, setValue] = React.useState(0);
  const [customerData, setCustomerData] = useState({
    person_in_charge: customer?.person_in_charge || 'N/A',
    email: customer?.email || 'N/A',
    contact: customer?.contact || 'N/A',
    pais: customer?.pais?.label || 'N/A',
    departamento: customer?.departamento?.label || 'N/A',
    municipio: customer?.municipio?.label || 'N/A',
    address: customer?.address || 'N/A',
    start_date: customer?.start_date || 'N/A',
    second_person_in_charge: customer?.second_person_in_charge || 'N/A',
    second_customer_contact: customer?.second_customer_contact || 'N/A',
    is_trial: customer?.is_trial ?? false,
    payment_vencido: customer?.payment_vencido ?? false,
    trial_ends_at: customer?.trial_ends_at || null,
    subscription_ends_at: customer?.subscription_ends_at || null,
  });

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [message_alert_snack, setMessageAlertSnack] = React.useState('');
  const [type_alert_snack, setTypeAlertSnack] = React.useState('success');

  useEffect(() => {
    setCustomerData(customer);
    setCustomerUpdateId(customer.id);
  }, [customer]);

  useEffect(() => {
    if (customer.applications && customer.applications.length > 0) {
      setCustomerUpdateId(customer.id);
      const firstApp = customer.applications[0];
      handleChangePermissions(0, firstApp.idCustomerApplication);
    }
  }, [customer.applications]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChangePermissions = async (newValue: number, idCustomerApplication: string) => {
    const response = await dispatch(
      getApplicationsPermissionsCustomerStore(idCustomerApplication, customer.id)
    );
    setValue(newValue);
  };

  return (
    <>
      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={message_alert_snack}
        severity={type_alert_snack}
      />

      <div style={{ widows: '100%' }}>
        <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>
          Detalle Cliente
        </Typography>
        <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
          <Typography color="textPrimary" sx={{ fontWeight: 700 }}>
            Manager
          </Typography>
          <Link color="inherit" to="/manager/clientes">
            Listar Clientes
          </Link>
          <Typography color="textPrimary">Detalle Cliente</Typography>
        </Breadcrumbs>

        <Divider sx={{ marginBottom: 3 }} />

        <Grid container spacing={2} sx={{ marginTop: 7 }}>
          <Grid size={4}>
            <Card
              sx={{
                position: 'sticky',
                top: 15,
                alignSelf: 'flex-start',
                height: 'fit-content', // Ajusta a la altura del contenido
                zIndex: 10,
                alignItems: 'center',
                p: 3,
                borderRadius: 2,
                boxShadow: 3,
                bgcolor: 'background.paper',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  mb: 3,
                  mt: 2,
                }}
              >
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: 'primary.main',
                    fontSize: '2rem',
                    mb: 2,
                    boxShadow: 2,
                  }}
                >
                  {customer?.name ? customer.name.charAt(0).toUpperCase() : 'C'}
                </Avatar>
                <Typography
                  variant="h5"
                  sx={{
                    textAlign: 'center',
                    fontWeight: '800',
                    textTransform: 'capitalize',
                    color: 'text.primary',
                  }}
                >
                  {customer.name}
                </Typography>
                <Box sx={{ mt: 1.5 }}>
                  <Chip
                    icon={<VerifiedUser sx={{ fontSize: '1rem !important' }} />}
                    label={'Activo'}
                    sx={{
                      color: '#2e7d32',
                      bgcolor: '#e8f5e9',
                      fontWeight: 600,
                      px: 1,
                      borderRadius: '8px',
                    }}
                  />
                </Box>
              </Box>

              <Divider sx={{ mb: 2 }} />

              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                  mb: 1,
                }}
              >
                Información Principal
              </Typography>

              <List dense disablePadding sx={{ mb: 2 }}>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Person color="primary" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Responsable"
                    secondary={customerData.person_in_charge}
                    primaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
                    secondaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: 500,
                      color: 'text.primary',
                    }}
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Email color="primary" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Email"
                    secondary={customerData.email}
                    primaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
                    secondaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: 500,
                      color: 'text.primary',
                    }}
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Phone color="primary" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Contacto"
                    secondary={customerData.contact}
                    primaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
                    secondaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: 500,
                      color: 'text.primary',
                    }}
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Event color="primary" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Fecha Registro"
                    secondary={formatDateToYmd(customerData.start_date)}
                    primaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
                    secondaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: 500,
                      color: 'text.primary',
                    }}
                  />
                </ListItem>
              </List>

              <Divider sx={{ mb: 2 }} />

              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                  mb: 1,
                }}
              >
                Ubicación
              </Typography>

              <List dense disablePadding sx={{ mb: 2 }}>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <LocationOn color="primary" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Dirección"
                    secondary={`${customerData.address} - ${customerData?.municipio?.label || 'N/A'}, ${customerData?.departamento?.label || 'N/A'}, ${customerData?.pais?.label || 'N/A'}`}
                    primaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
                    secondaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: 500,
                      color: 'text.primary',
                    }}
                  />
                </ListItem>
              </List>

              <Divider sx={{ mb: 2 }} />

              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                  mb: 1,
                }}
              >
                Estado de Suscripción
              </Typography>

              <Stack spacing={1.5} sx={{ mb: 2 }}>
                {customerData?.is_trial && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      bgcolor: '#e3f2fd',
                      p: 1.5,
                      borderRadius: 2,
                    }}
                  >
                    <Star sx={{ color: '#1976d2', mr: 1.5 }} />
                    <Box>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Periodo de Prueba
                      </Typography>
                      <Typography variant="body2" fontWeight="bold" color="#1976d2">
                        Hasta{' '}
                        {customerData?.trial_ends_at
                          ? formatDateToYmd(customerData.trial_ends_at)
                          : 'N/A'}
                      </Typography>
                    </Box>
                  </Box>
                )}

                {!customerData?.is_trial && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      bgcolor: '#f5f5f5',
                      p: 1.5,
                      borderRadius: 2,
                    }}
                  >
                    <Payment sx={{ color: 'text.secondary', mr: 1.5 }} />
                    <Box>
                      <Typography variant="caption" color="text.secondary" display="block">
                        Suscripción hasta
                      </Typography>
                      <Typography variant="body2" fontWeight="bold">
                        {customerData?.subscription_ends_at
                          ? formatDateToYmd(customerData.subscription_ends_at)
                          : 'N/A'}
                      </Typography>
                    </Box>
                  </Box>
                )}

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    bgcolor: customerData?.payment_vencido ? '#fdeded' : '#f1f8e9',
                    p: 1.5,
                    borderRadius: 2,
                  }}
                >
                  <Payment
                    sx={{ color: customerData?.payment_vencido ? '#d32f2f' : '#388e3c', mr: 1.5 }}
                  />
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      Estado de Pago
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      color={customerData?.payment_vencido ? '#d32f2f' : '#388e3c'}
                    >
                      {customerData?.payment_vencido ? 'Vencido' : 'Al día'}
                    </Typography>
                  </Box>
                </Box>
              </Stack>

              <Divider sx={{ mb: 2 }} />

              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: 1,
                  mb: 1,
                }}
              >
                Contacto Alternativo
              </Typography>

              <List dense disablePadding>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Person color="primary" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Responsable Secundario"
                    secondary={customerData.second_person_in_charge}
                    primaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
                    secondaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: 500,
                      color: 'text.primary',
                    }}
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Phone color="primary" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Contacto Secundario"
                    secondary={customerData.second_customer_contact}
                    primaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
                    secondaryTypographyProps={{
                      variant: 'body2',
                      fontWeight: 500,
                      color: 'text.primary',
                    }}
                  />
                </ListItem>
              </List>

              {/* {
                        customer.status == 1 && <div style={{ width: '100%', textAlign: 'center'}}>
                        <Button onClick={ () => editarCustomer( customer.id ) } size='small' sx={{ marginTop: 3 }} variant="contained">Editar</Button>
                      </div>
                    } */}
            </Card>
          </Grid>
          <Grid size={8}>
            <Box sx={{ width: '100%' }}>
              <Box>
                <Tabs
                  TabIndicatorProps={{
                    style: { display: 'none' }, // También puedes usar esta propiedad directamente
                  }}
                  selectionFollowsFocus={true}
                  value={value}
                  onChange={handleChange}
                  aria-label="tabs detalle clientes"
                >
                  {customer?.applications?.map((app: any, index: any) => (
                    <CustomButtonTab
                      key={app.id} // Importante: usa una key única
                      icon={<Apps />}
                      iconPosition="start"
                      label={app.name} // Usa el nombre de la aplicación como label
                      {...a11yProps(index + 1)} // Ajusta el índice según tus tabs estáticos
                      onClick={() => handleChangePermissions(index, app.idCustomerApplication)}
                    />
                  ))}
                </Tabs>
              </Box>
            </Box>

            <Card
              sx={{
                alignItems: 'center',
                p: 3,
                borderRadius: 2,
                boxShadow: 3,
                bgcolor: 'background.paper',
                marginTop: 3,
              }}
            >
              <CustomTabPanel value={value} index={value}>
                {
                  // <DetailPermissions/>
                  customer && Object.keys(customer).length > 0 && <DetalleModuloPermisosCustomer />
                }
              </CustomTabPanel>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
